import { useQuery } from '@tanstack/react-query'
import { sportsApi } from '../api/client'
import type { Sport } from '../types'

export function useStandings(sport: Sport) {
  return useQuery({
    queryKey: ['standings', sport],
    queryFn: () => sportsApi.getStandings(sport),
    staleTime: 5 * 60 * 1000, // 5 minutes - standings don't change often
  })
}
